import CategoryImage from "../core/CategoryImage.tsx";
import { Link, useNavigate } from "react-router-dom";
import ReactiveToggle from "../../core/ReactiveToggle";
import { ReactNode, useCallback } from "react";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle";

const CategoryListElem = ({
  classname,
  slug,
  icon,
  routeTo,
  children,
}: {
  classname: string;
  slug: string;
  routeTo: string;
  icon: ReactNode;
  children: ReactNode;
}) => {
  const navigate = useNavigate();

  const selectCategory = useCallback(() => {
    navigate(routeTo);
  }, [routeTo]);

  return (
    <ReactiveToggle transitional={selectCategory}>
      {(handleClick, isPending) => (
        <Link
          to={routeTo}
          onClick={(e) => {
            e.preventDefault();
            handleClick();
          }}
          className={classname}
        >
          <figure className="aspect-square h-full">
            <CategoryImage
              slug={slug}
              sizes="128px"
              className="object-cover w-full h-full object-center rounded-full"
              size={10}
            />
          </figure>
          {children}
          {isPending ? LOADING_CIRCLE : icon}
        </Link>
      )}
    </ReactiveToggle>
  );
};
export default CategoryListElem;
